export default {
  /**
   * Set the List items
   *
   * @param state
   * @param items
   */
  setTeacherGroupMemberNotInList(state, items) {
    state.items = items;
  },

  /**
   * Set List pagination meta
   *
   * @param state
   * @param pagination
   */
  setTeacherGroupMemberNotInListPagination(state, pagination) {
    state.pagination = pagination;
  },

  /**
   * Set List current page
   *
   * @param state
   * @param currentPage
   */
  setTeacherGroupMemberNotInListPage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   *
   * @param state
   * @param filters
   */
  setTeacherGroupMemberNotInListFilters(state, filters) {
    console.log("Filters : ", filters);

    state.filters = filters;
  },

  /**
   * Flip switch.
   *
   * @param state
   * @param employeeId
   */
  switchTeacherGroupMemberSelectionSave(state, employeeId) {
    console.log("Info: ", state, employeeId);

    const index = state.items.findIndex((e) => e.id === employeeId);
    console.log("Matched row: ", state.items[index]);

    state.items[index].selected = !state.items[index].selected;
    console.log("Changed row: ", state.items[index]);
  },
};
